// 视图组件


const view = {
  tabs: () => import('@/layouts/tabs'),
  blank: () => import('@/layouts/BlankView'),
  page: () => import('@/layouts/PageView')
}


// 路由组件注册
const routerMap = {
  workspace: {
    path: '/home',
    name: '首页',
    icon: 'home',

    component: () => import('@/pages/web/home/index')
  },
  // demo: {
  // 	name: '示例',
  // 	component: view.page
  // },
  // "/demo/normalList": {
  // 	path: '/demo/normalList',
  // 	name: "常规列表",
  // 	component: () => import('@/pages/web/demo/normalList')
  // },


  /* 公共模块Start */
  comm: {
    name: '公共',
    icon: 'appstore',
    component: view.page
  },
  "/comm/clueRuleConfig": {
    path: '/comm/clueRuleConfig',
    name: "clueRuleConfig",
    component: () => import('@/pages/web/comm/clueRuleConfig')
  },
  "/comm/clueTouchChannel": {
    path: '/comm/clueTouchChannel',
    name: "触达渠道配置",
    component: () => import('@/pages/web/comm/clueTouchChannel')
  },
  "/comm/userManage": {
    path: '/comm/userManage',
    name: "用户管理",
    component: () => import('@/pages/web/comm/userManage')
  },
  "/comm/dealerManage": {
    path: '/comm/dealerManage',
    name: "经销商管理",
    component: () => import('@/pages/web/comm/dealerManage')
  },
  "/comm/roleManage": {
    path: '/comm/roleManage',
    name: "角色管理",
    component: () => import('@/pages/web/comm/roleManage')
  },
  "/comm/menuManage": {
    path: '/comm/menuManage',
    name: "菜单管理",
    component: () => import('@/pages/web/comm/menuManage')
  },
  "/comm/commBaseCodeManage": {
    path: '/comm/commBaseCodeManage',
    name: "通用代码管理",
    component: () => import('@/pages/web/comm/commBaseCodeManage')
  },
  "/comm/ecSettingsManage": {
    path: '/comm/ecSettingsManage',
    name: "参数管理",
    component: () => import('@/pages/web/comm/ecSettingsManage')
  },
  // qf29
  "/comm/bicvalList": {
    path: '/comm/bicvalList',
    name: "值列表管理",
    component: () => import('@/pages/web/comm/valManage/valList')
  },
  "/comm/bicValDetail": {
    path: '/comm/bicValDetail/:id/:domain?',
    name: "值列表>>详情",
    component: () => import('@/pages/web/comm/valManage/valDetail')
  },
  "/comm/logManage": {
    path: '/comm/logManage',
    name: "系统日志",
    component: () => import('@/pages/web/comm/logManage/logManage')
  },

  clue: {
    name: '线索管理',
    icon: 'container',
    component: view.page
  },
  "/clue/clueManage": {
    path: '/clue/clueManage',
    name: "线索管理",
    component: () => import('@/pages/web/clue/clueManage')
  },
  "/clue/customerMap": {
    path: '/clue/customerMap',
    name: "获客地图",
    component: () => import('@/pages/web/clue/customerMap')
  },
  "/clue/clueReportManage": {
    path: '/clue/clueReportManage',
    name: "跟进记录",
    component: () => import('@/pages/web/clue/clueReportManage')
  },
  "/clue/saleCluePool": {
    path: '/clue/saleCluePool',
    name: "线索池",
    component: () => import('@/pages/web/clue/saleCluePool')
  },
  "/clue/leadsAssigned": {
    path: '/clue/leadsAssigned',
    name: "已分配线索",
    component: () => import('@/pages/web/clue/leadsAssigned')
  },
  "/clue/clueCollection": {
    path: '/clue/clueCollection',
    name: "线索领取记录",
    component: () => import('@/pages/web/clue/clueCollection')
  },
  "/comm/memberManage": {
    path: '/comm/memberManage',
    name: "成员管理",
    component: () => import('@/pages/web/comm/memberManage')
  },

  //营销模块
  market: {
    name: '营销管理',
    icon: 'container',
    component: view.page
  },
  "/market/articleMarket": {
    path: '/market/articleMarket',
    name: "文章营销",
    component: () => import('@/pages/web/market/articleMarket')
  },
  "/market/videoMarket": {
    path: '/market/videoMarket',
    name: "视频营销",
    component: () => import('@/pages/web/market/videoMarket')
  },
  "/market/posterManage": {
    path: '/market/posterManage',
    name: '海报管理',
    component: () => import('@/pages/web/market/posterManage')
  },
  "/market/activeDZP": {
    path: '/market/activeDZP',
    name: '大转盘',
    component: () => import('@/pages/web/market/activeDZP')
  },
  "/market/activeGGL": {
    path: '/market/activeGGL',
    name: '刮刮乐',
    component: () => import('@/pages/web/market/activeGGL')
  },
  "/market/activeXYFK": {
    path: '/market/activeXYFK',
    name: '幸运抽奖',
    component: () => import('@/pages/web/market/activeXYFK')
  },

  bigCustomer: {
    name: '大客户拜访',
    icon: 'container',
    component: view.page
  },
  "/bigCustomer/visit": {
    path: '/bigCustomer/visit',
    name: "大客户拜访记录",
    // component: () => import('@/pages/web/activity/plan')
    component: () => import('@/pages/web/bigCustomer/visit/visitRecordList.vue')
  },
  "/bigCustomer/visitDetail": {
    path: '/bigCustomer/visitDetail/:id',///:state?
    name: '大客户拜访记录>>详情',
    component: () => import('@/pages/web/bigCustomer/visit/visitRecordDetail.vue'),
  },
  "/bigCustomer/visitPlan": {
    path: '/bigCustomer/visitPlan',
    name: '大客户拜访计划',
    component: () => import('@/pages/web/bigCustomer/plan/list.vue')
  },
  "/bigCustomer/followRecord": {
    path: '/bigCustomer/followRecord',
    name: "意向大客户明细",
    // component: () => import('@/pages/web/activity/plan')
    component: () => import('@/pages/web/bigCustomer/followRecord/followRecordList.vue')
  },
  "/bigCustomer/visitTask": {
    path: '/bigCustomer/visitTask',
    name: "大客户拜访任务",
    component: () => import('@/pages/web/bigCustomer/visitTask/visitTaskList.vue')
  },
  /** 工作流*/
  workflow: {
    name: '工作流',
    icon: 'book',
    component: view.page
  },
  "/workflow/workflow": {
    path: "/workflow/workflow",
    name: "工作流配置",
    component: () => import('@/pages/web/workflow/workflow')
  },
  "/workflow/modelManage": {
    path: "/workflow/modelManage",
    name: "工作流模型",
    component: () => import('@/pages/web/workflow/modelManage')
  },
  "/workflow/workflowManage": {
    path: "/workflow/workflowManage",
    name: "流程管理",
    component: () => import('@/pages/web/workflow/workflowManage')
  },
  "/workflow/doingWorkflow": {
    path: "/workflow/doingWorkflow",
    name: "运行中的流程",
    component: () => import('@/pages/web/workflow/doingWorkflow')
  },
  "/workflow/workflowHistory": {
    path: "/workflow/workflowHistory",
    name: "办理历史",
    component: () => import('@/pages/web/workflow/workflowHistory')
  },

  /* 公共模块Start */
  operate: {
    name: '客户运营',
    icon: 'team',
    component: view.page
  },

  "/operate/MassSendCircle": {
    path: '/operate/MassSendCircle',
    name: "群发朋友圈",
    component: () => import('@/pages/web/operate/MassSendCircle')
  },
  "/operate/MassSendCustomer": {
    path: '/operate/MassSendCustomer',
    name: "群发客户群消息",
    component: () => import('@/pages/web/operate/MassSendCustomer')
  },
  "/operate/MassSendCust": {
    path: '/operate/MassSendCust',
    name: "群发客户消息",
    component: () => import('@/pages/web/operate/MassSendCust')
  },
  "/operate/groupWelcomeResources": {
    path: '/operate/groupWelcomeResources',
    name: "入群欢迎语素材",
    component: () => import('@/pages/web/operate/groupWelcomeResources')
  },
  "/operate/AutoReplySetUp": {
    path: '/operate/AutoReplySetUp',
    name: "自动欢迎语",
    component: () => import('@/pages/web/operate/AutoReplySetUp')
  },
  "/operate/fission": {
    path: '/operate/fission',
    name: "客户裂变",
    component: () => import('@/pages/web/operate/fission')
  },
  "/operate/fissionStatistics": {
    path: '/operate/fissionStatistics',
    name: "客户裂变统计",
    component: () => import('@/pages/web/operate/fissionStatistics')
  },
  "/operate/ProductBrochure": {
    path: '/operate/ProductBrochure',
    name: "产品宣传册",
    component: () => import('@/pages/web/operate/ProductBrochure')
  },
  "/operate/EnterpriseWeChatCode": {
    path: '/operate/EnterpriseWechatCode',
    name: "企微活码",
    component: () => import('@/pages/web/operate/EnterpriseWeChatCode')
  },
  "/operate/BulkAssistant": {
    path: '/operate/BulkAssistant',
    name: "客户SOP群发",
    component: () => import('@/pages/web/operate/BulkAssistant')
  },
  /* 公共Start */
  client: {
    name: '客户',
    icon: 'user',
    component: view.page
  },
  "/client/labelManage": {
    path: '/client/labelManage',
    name: "标签管理表",
    component: () => import('@/pages/web/client/labelManage')
  },
  "/client/clientFollowUp": {
    path: '/client/clientFollowUp',
    name: "客户跟进记录表",
    component: () => import('@/pages/web/client/clientFollowUp')
  },
  "/client/clientServer": {
    path: '/client/clientServer',
    name: "客户共享记录表",
    component: () => import('@/pages/web/client/clientServer')
  },
  "/client/clientTag": {
    path: '/client/clientTag',
    name: "客户标签表",
    component: () => import('@/pages/web/client/clientTag')
  },
  "/client/clientInherit": {
    path: '/client/clientInherit',
    name: "离职继承",
    component: () => import('@/pages/web/client/clientInherit')
  },
  "/client/clientInheritRecord": {
    path: '/client/clientInheritRecord',
    name: "离职继承记录",
    component: () => import('@/pages/web/client/clientInheritRecord')
  },
  "/client/customer": {
    path: '/client/customer',
    name: "客户管理",
    component: () => import('@/pages/web/client/customer')
  },
  "/client/customerarchives": {
    path: '/client/customerarchives',
    name: "客户档案",
    component: () => import('@/pages/web/client/customerarchives')
  },
  "/client/maintainCustomer": {
    path: '/client/maintainCustomer',
    name: "保有客户档案",
    component: () => import('@/pages/web/client/maintainCustomer')
  },
  "/client/haveCar": {
    path: '/client/haveCar',
    name: "保有车辆",
    component: () => import('@/pages/web/client/haveCar')
  },

  "/client/timedTask": {
    path: '/client/timedTask',
    name: "定时任务",
    component: () => import('@/pages/web/client/timedTask')
  },
  /* 报表 start */
  report: {
    name: '报表',
    icon: 'user',
    component: view.page
  },
  "/report/downloadCenter": {
    path: '/report/downloadCenter',
    name: "下载中心",
    component: () => import('@/pages/web/report/downloadCenter')
  },
  "/report/customerReport": {
    path: '/report/customerReport',
    name: "客户报表",
    component: () => import('@/pages/web/report/customerReport')
  },
  "/report/customerReportNoStrain": {
    path: '/report/customerReportNoStrain',
    name: "客户报表(无品系)",
    component: () => import('@/pages/web/report/customerReportNoStrain')
  },
  "/report/clueReport": {
    path: '/report/clueReport',
    name: "线索报表",
    component: () => import('@/pages/web/report/clueReport')
  },
  "/report/clueReportNoStrain": {
    path: '/report/clueReportNoStrain',
    name: "线索报表(无品系)",
    component: () => import('@/pages/web/report/clueReportNoStrain')
  },
  "/report/custStructureReport": {
    path: '/report/custStructureReport',
    name: "客户结构",
    component: () => import('@/pages/web/report/custStructureReport')
  },
  "/report/custStructureReportNoStrain": {
    path: '/report/custStructureReportNoStrain',
    name: "客户结构(无品系)",
    component: () => import('@/pages/web/report/custStructureReportNoStrain')
  },
  "/report/bigCustClueReport": {
    path: '/report/bigCustClueReport',
    name: "大客户开发",
    component: () => import('@/pages/web/report/bigCustClueReport')
  },
  "/report/bigCustClueReportNoStrain": {
    path: '/report/bigCustClueReportNoStrain',
    name: "大客户开发(无品系)",
    component: () => import('@/pages/web/report/bigCustClueReportNoStrain')
  },
  "/report/custIndustryReport": {
    path: '/report/custIndustryReport',
    name: "客户行业",
    component: () => import('@/pages/web/report/custIndustryReport')
  },
  "/report/custSourceReport": {
    path: '/report/custSourceReport',
    name: "客户来源",
    component: () => import('@/pages/web/report/custSourceReport')
  },
  "/report/custSourceReportNoStrain": {
    path: '/report/custSourceReportNoStrain',
    name: "客户来源(无品系)",
    component: () => import('@/pages/web/report/custSourceReportNoStrain')
  },
  "/report/custKnownWayReport": {
    path: '/report/custKnownWayReport',
    name: "客户了解柳汽的方式",
    component: () => import('@/pages/web/report/custKnownWayReport')
  },
  "/report/custKnownWayReportNoStrain": {
    path: '/report/custKnownWayReportNoStrain',
    name: "客户了解柳汽的方式(无品系)",
    component: () => import('@/pages/web/report/custKnownWayReportNoStrain')
  },
  "/report/custFollowWithReport": {
    path: '/report/custFollowWithReport',
    name: "客户关注点",
    component: () => import('@/pages/web/report/custFollowWithReport')
  },
  "/report/custFollowWithReportNoStrain": {
    path: '/report/custFollowWithReportNoStrain',
    name: "客户关注点(无品系)",
    component: () => import('@/pages/web/report/custFollowWithReportNoStrain')
  },
  "/report/clueFailReport": {
    path: '/report/clueFailReport',
    name: "战败原因分析",
    component: () => import('@/pages/web/report/clueFailReport')
  },
  "/report/activityReport": {
    path: '/report/activityReport',
    name: "活动开展报表",
    component: () => import('@/pages/web/report/activityReport')
  },
  "/report/activityListReport": {
    path: '/report/activityListReport',
    name: "活动开展列表",
    component: () => import('@/pages/web/report/activityListReport')
  },
  "/report/activityEffectReport": {
    path: '/report/activityEffectReport',
    name: "活动效果报表",
    component: () => import('@/pages/web/report/activityEffectReport')
  },
  "/report/mainCustReport": {
    path: '/report/mainCustReport',
    name: "月度新车保客档案信息报表",
    component: () => import('@/pages/web/report/mainCustReport')
  },
  /* 报表 end */

  ans: {
    name: '传播内容',
    icon: 'container',
    component: view.page
  },
  "/answer/commonAnswer": {
    path: '/answer/commonAnswer',
    name: "常见问答",
    component: () => import('@/pages/web/answer/commonAnswer')
  },
  "/answer/commonSpeech": {
    path: '/answer/commonSpeech',
    name: "常用话术",
    component: () => import('@/pages/web/answer/commonSpeech')
  },
  "/answer/commonFile": {
    path: '/answer/commonFile',
    name: "对外资料",
    component: () => import('@/pages/web/answer/commonFile')
  },
  "/answer/commonKeyWords": {
    path: '/answer/commonKeyWords',
    name: "关键词管理",
    component: () => import('@/pages/web/answer/commonKeyWords')
  },

  /* 公共模块Start */
  activity: {
    name: '计划管理',
    icon: 'team',
    component: view.page
  },

  "/activity/plan": {
    path: '/activity/plan',
    name: "活动计划",
    component: () => import('@/pages/web/activity/plan')
  },
  "/activity/attractingCustomers": {
    path: '/activity/attractingCustomers',
    name: "集客计划",
    component: () => import('@/pages/web/activity/attractingCustomers')
  },
  "/activity/leadPlan": {
    path: '/activity/leadPlan',
    name: "线索计划",
    component: () => import('@/pages/web/activity/leadPlan')
  },
  "/activity/visitPlan": {
    path: '/activity/visitPlan',
    name: "线索计划",
    component: () => import('@/pages/web/activity/visitPlan')
  },
  /* 活动管理Start */
  activityManage: {
    name: '活动管理',
    icon: 'gift',
    component: view.page
  },
  "/activityManage/activityList": {
    path: '/activityManage/activityList',
    name: "活动管理",
    component: () => import('@/pages/web/activityManage/activityList')
  },
  "/activityManage/activityAccount": {
    path: '/activityManage/activityAccount',
    name: "活动报账",
    component: () => import('@/pages/web/activityManage/activityAccount')
  },
  "/activityManage/activityType": {
    path: '/activityManage/activityType',
    name: "活动类型管理",
    component: () => import('@/pages/web/activityManage/activityType')
  },
   // 广宣物料管理
   publicizeMaterialManagement: {
    name: '广宣物料',
    icon: 'gift',
    component: view.page
  },
  "/publicizeMaterialManagement/publicizeMaterialMaintenance": {
    path: '/publicizeMaterialManagement/publicizeMaterialMaintenance',
    name: '广宣物料维护',
    component: () => import('@/pages/web/publicizeMaterialManagement/publicizeMaterialMaintenance.vue')
  },
  "/publicizeMaterialManagement/publicizeMaterialQuery": {
    path: '/publicizeMaterialManagement/publicizeMaterialQuery',
    name: '广宣物料查询',
    component: () => import('@/pages/web/publicizeMaterialManagement/publicizeMaterialQuery.vue')
  },
  "/publicizeMaterialManagement/advertiseMaterialRequisition": {
    path: '/publicizeMaterialManagement/advertiseMaterialRequisition',
    name: '广宣物料申领',
    component: () => import('@/pages/web/publicizeMaterialManagement/advertiseMaterialRequisition.vue')
  },
  "/publicizeMaterialManagement/materialApplyQuota": {
    path: '/publicizeMaterialManagement/materialApplyQuota',
    name: '物料申领额度维护',
    component: () => import('@/pages/web/publicizeMaterialManagement/materialApplyQuota.vue')
  },
  "/publicizeMaterialManagement/applyOrder": {
    path: '/publicizeMaterialManagement/applyOrder/:id',
    name: '广宣物料申领>>下单',
    component: () => import('@/pages/web/publicizeMaterialManagement/applyOrder.vue')
  },
  "/publicizeMaterialManagement/applyOrderDetail": {
    path: '/publicizeMaterialManagement/applyOrderDetail/:id',
    name: '广宣物料申领>>详细',
    component: () => import('@/pages/web/publicizeMaterialManagement/applyOrderDetail.vue')
  },
  "/publicizeMaterialManagement/applyOrderApprove": {
    path: '/publicizeMaterialManagement/applyOrderApprove/:id',
    name: '广宣物料申领>>审核',
    component: () => import('@/pages/web/publicizeMaterialManagement/applyOrderApprove.vue')
  },
  "/publicizeMaterialManagement/publicizeMaterialInWarehouse": {
    path: '/publicizeMaterialManagement/publicizeMaterialInWarehouse',
    name: '广宣物料入库查询',
    component: () => import('@/pages/web/publicizeMaterialManagement/publicizeMaterialInWarehouse.vue')
  },
  "/publicizeMaterialManagement/publicizeMaterialApplicationDetails": {
    path: '/publicizeMaterialManagement/publicizeMaterialApplicationDetails',
    name: '广宣物料申请明细',
    component: () => import('@/pages/web/publicizeMaterialManagement/publicizeMaterialApplicationDetails.vue')
  },
  "/publicizeMaterialManagement/publicizeMaterialOutWarehouse": {
    path: '/publicizeMaterialManagement/publicizeMaterialOutWarehouse',
    name: '广宣物料申请出库',
    component: () => import('@/pages/web/publicizeMaterialManagement/publicizeMaterialOutWarehouse.vue')
  },
  "/publicizeMaterialManagement/addMaterial": {
    path: '/publicizeMaterialManagement/addMaterial/:id',
    name: '广宣物料>>新增',
    component: () => import('@/pages/web/publicizeMaterialManagement/addMaterial.vue')
  },
  "/publicizeMaterialManagement/editMaterial": {
    path: '/publicizeMaterialManagement/editMaterial/:id',
    name: '广宣物料>>修改',
    component: () => import('@/pages/web/publicizeMaterialManagement/editMaterial.vue')
  },
  "/publicizeMaterialManagement/detailMaterial": {
    path: '/publicizeMaterialManagement/detailMaterial/:id',
    name: '广宣物料>>详细信息',
    component: () => import('@/pages/web/publicizeMaterialManagement/detailMaterial.vue')
  },
  "/publicizeMaterialManagement/addInWarehouse": {
    path: '/publicizeMaterialManagement/addInWarehouse/:id',
    name: '广宣物料>>增加入库',
    component: () => import('@/pages/web/publicizeMaterialManagement/addInWarehouse.vue')
  },
  "/publicizeMaterialManagement/addOutWarehouse": {
    path: '/publicizeMaterialManagement/addOutWarehouse/:id',
    name: '广宣物料>>减少入库',
    component: () => import('@/pages/web/publicizeMaterialManagement/addOutWarehouse.vue')
  },
  "/publicizeMaterialManagement/address": {
    path: '/publicizeMaterialManagement/address',
    name: '收货地址',
    component: () => import('@/pages/web/publicizeMaterialManagement/address/index.vue')
  },
  "/publicizeMaterialManagement/reviewInfo": {
    path: '/publicizeMaterialManagement/reviewInfo',
    name: '报销信息审核信息>>查看',
    component: () => import('@/pages/web/publicizeMaterialManagement/reviewInfo/index.vue')
  },
  "/publicizeMaterialManagement/campaignInfo": {
    path: '/publicizeMaterialManagement/campaignInfo',
    name: '推广活动审核信息>>查看',
    component: () => import('@/pages/web/publicizeMaterialManagement/campaignInfo/index.vue')
  },
  "/publicizeMaterialManagement/itemRequisition": {
    path: '/publicizeMaterialManagement/itemRequisition',
    name: '物料申请审核信息>>查看',
    component: () => import('@/pages/web/publicizeMaterialManagement/itemRequisition/index.vue')
  },
  "/publicizeMaterialManagement/myToDolist": {
    path: '/publicizeMaterialManagement/myToDolist',
    name: '我的待办',
    component: () => import('@/pages/web/publicizeMaterialManagement/myToDolist.vue')
  },
  "/publicizeMaterialManagement/reimbursementLis": {
    path: '/publicizeMaterialManagement/reimbursementLis',
    name: '报账审批进度查询',
    component: () => import('@/pages/web/publicizeMaterialManagement/reimbursementLis.vue')
  },
  "/publicizeMaterialManagement/promotionActivitiesList": {
    path: '/publicizeMaterialManagement/promotionActivitiesList',
    name: '推广活动审批查询',
    component: () => import('@/pages/web/publicizeMaterialManagement/promotionActivitiesList.vue')
  },
  "/publicizeMaterialManagement/materialApplicationList": {
    path: '/publicizeMaterialManagement/materialApplicationList',
    name: '物料申请状态',
    component: () => import('@/pages/web/publicizeMaterialManagement/materialApplicationList.vue')
  },
  "/publicizeMaterialManagement/delivery": {
    path: '/publicizeMaterialManagement/delivery',
    name: '物料发货',
    component: () => import('@/pages/web/publicizeMaterialManagement/delivery.vue')
  },
  "/publicizeMaterialManagement/deliveryDetail": {
    path: '/publicizeMaterialManagement/deliveryDetail/:id',
    name: '物料发货>>详细',
    component: () => import('@/pages/web/publicizeMaterialManagement/deliveryDetail.vue')
  },


  /* 市场活动 */
  terminalActivity: {
    name: '市场活动',
    icon: 'gift',
    component: view.page
  },
  "/terminalActivity/planDelivery": {
    path: '/terminalActivity/planDelivery',
    name: '计划下发',
    component: () => import('@/pages/web/terminalActivity/maintainActivity.vue'),
  },
  "/terminalActivity/addActivity": {
    path: '/terminalActivity/addActivity/:id',
    name: '计划下发>>新增',
    component: () => import('@/pages/web/terminalActivity/addActivity.vue'),
  },
  "/terminalActivity/editActivity": {
    path: '/terminalActivity/editActivity/:id',
    name: '计划下发>>编辑',
    component: () => import('@/pages/web/terminalActivity/editActivity.vue'),
  },
  "/terminalActivity/detailsActivity": {
    path: '/terminalActivity/detailsActivity/:id/:state?',
    name: '计划下发>>详情',
    component: () => import('@/pages/web/terminalActivity/detailsActivity.vue'),
  },
  "/terminalActivity/applyActivityList": {
    path: '/terminalActivity/applyActivityList',
    name: '可提报计划',
    component: () => import('@/pages/web/terminalActivity/applyActivityList.vue'),
  },
  "/terminalActivity/signActivity": {
    path: '/terminalActivity/signActivity/:id/:type?',
    name: '市场活动>>提报',
    component: () => import('@/pages/web/terminalActivity/signActivity.vue'),
  },
  "/terminalActivity/signIndex": {
    path: '/terminalActivity/signIndex',
    name: '活动提报',
    component: () => import('@/pages/web/terminalActivity/signIndex.vue'),
  },
  "/terminalActivity/signDetails": {
    path: '/terminalActivity/signDetails/:id',
    name: '活动提报>>详情',
    component: () => import('@/pages/web/terminalActivity/signDetails.vue'),
  },
  "/terminalActivity/editSignActivity": {
    path: '/terminalActivity/editSignActivity/:id',
    name: '活动提报>>编辑',
    component: () => import('@/pages/web/terminalActivity/editSignActivity.vue'),
  },
  "/terminalActivity/editSignActivityDate": {
    path: '/terminalActivity/editSignActivityDate/:id/:state?',
    name: '活动提报>>调整时间',
    component: () => import('@/pages/web/terminalActivity/editSignActivityDate.vue'),
  },
  "/terminalActivity/activityReimbursement": {
    path: '/terminalActivity/activityReimbursement',
    name: '活动核销',
    component: () => import('@/pages/web/terminalActivity/activityReimbursement/activityReimbursement.vue'),
  },
  "/terminalActivity/detailedReimbursement": {
    path: '/terminalActivity/detailedReimbursement/:id',
    name: '活动核销>>详请',
    component: () => import('@/pages/web/terminalActivity/activityReimbursement/detailedReimbursement.vue'),
  },
  "/terminalActivity/executeReimbursement": {
    path: '/terminalActivity/executeReimbursement/:id',
    name: '活动核销>>反馈',
    component: () => import('@/pages/web/terminalActivity/activityReimbursement/executeReimbursement.vue'),
  },
  // 经销商费用维护
  "/terminalActivity/dealerAmountMList": {
    path: '/terminalActivity/dealerAmountMList',
    name: '经销商费用维护',
    component: () => import('@/pages/web/terminalActivity/dealerAmount/list.vue'),
  },
  "/terminalActivity/dealerAmountMDetail": {
    path: '/terminalActivity/dealerAmountMDetail/:id/:view?',
    name: '经销商费用维护>>详情',
    component: () => import('@/pages/web/terminalActivity/dealerAmount/detail.vue'),
  },
  "/terminalActivity/delayApproveList": {
    path: '/terminalActivity/delayApproveList',
    name: '超期审批查看',
    component: () => import('@/pages/web/terminalActivity/delayApprove/list.vue'),
  },
  "/terminalActivity/actCustomerList": {
    path: '/terminalActivity/actCustomerList',
    name: '活动扫码集客',
    component: () => import('@/pages/web/terminalActivity/actCustomer/list.vue'),
  },
  "/terminalActivity/actCustomerDetail": {
    path: '/terminalActivity/actCustomerDetail/:type?/:id?/:seriesCode?',
    name: '活动扫码集客>>明细',
    component: () => import('@/pages/web/terminalActivity/actCustomer/detail.vue'),
  },
  "/terminalActivity/myToDolist": {
    path: '/terminalActivity/myToDolist',
    name: '我的待办',
    component: () => import('@/pages/web/terminalActivity/myToDolist.vue')
  },


  /* 系统通用 */
  login: {
    authority: '*',
    path: '/login',
    component: () => import('@/pages/login')
  },
  here: {
    path: '/here',
    component: () => import('@/pages/here')
  },
  /* root和workspace是在ebase-menu中手动添加的，所以不要修改 */
  root: {
    path: '/',
    name: '首页',
    redirect: '/login',
    component: view.tabs
  },
  dashboard: {
    name: 'Dashboard',
    component: view.blank
  },


  success: {
    name: '成功',
    component: () => import('@/pages/result/Success')
  },
  error: {
    name: '失败',
    component: () => import('@/pages/result/Error')
  },
  exception: {
    name: '异常页',
    icon: 'warning',
    component: view.blank
  },
  exp403: {
    authority: '*',
    name: 'exp403',
    path: '403',
    component: () => import('@/pages/exception/403')
  },
  exp404: {
    name: 'exp404',
    path: '404',
    component: () => import('@/pages/exception/404')
  },
  exp500: {
    name: 'exp500',
    path: '500',
    component: () => import('@/pages/exception/500')
  },

}
export default routerMap

